import React from 'react'
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';

function MainPage() {
  return (
   <div className="container">
            <br />
            <h1>
                CoPilot Agents
            </h1>
            <br />
        <Form>
        </Form>
    </div>
  )
}

export default MainPage